module.exports = __webpack_public_path__ + "img/Counter Icon 2@2x.9c5b2cb8.png";